/**
 * @fileoverview Utility for identifying common stop words (e.g., "the", "and", "is").
 * Based on the SpaCy English stop word list.
 */

/**
 * Checks word is in [320 commonly ignored "stop words 
 * "](https://raw.githubusercontent.com/igorbrigadir/stopwords/master/en/spacy.txt) 
 * in queries, using efficient JS Set method 
 * @param {string} word
 * @returns {Boolean}
*/
export function isWordCommonIgnored(word) {
  return stopwords.has(word.toLowerCase());
}

//@ts-ignore
const stopwords = new Set([
  "a", "about", "above", "across", "after", "afterwards", "again", "against", "all",
  "almost", "alone", "along", "already", "also", "although", "always", "am", "among",
  "amongst", "amount", "an", "and", "another", "any", "anyhow", "anyone", "anything",
  "anyway", "anywhere", "are", "around", "as", "at", "back", "be", "became", "because",
  "become", "becomes", "becoming", "been", "before", "beforehand", "behind", "being",
  "below", "beside", "besides", "between", "beyond", "both", "bottom", "but", "by",
  "ca", "call", "can", "cannot", "could", "did", "do", "does", "doing", "done", "down",
  "due", "during", "each", "eight", "either", "eleven", "else", "elsewhere", "empty",
  "enough", "even", "ever", "every", "everyone", "everything", "everywhere", "except",
  "few", "fifteen", "fifty", "first", "five", "for", "former", "formerly", "forty",
  "four", "from", "front", "full", "further", "get", "give", "go", "had", "has",
  "have", "he", "hence", "her", "here", "hereafter", "hereby", "herein", "hereupon",
  "hers", "herself", "him", "himself", "his", "how", "however", "hundred", "i", "if",
  "in", "indeed", "into", "is", "it", "its", "itself", "just", "keep", "last", "latter",
  "latterly", "least", "less", "made", "make", "many", "may", "me", "meanwhile",
  "might", "mine", "more", "moreover", "most", "mostly", "move", "much", "must", "my",
  "myself", "n't", "name", "namely", "neither", "never", "nevertheless", "next", "nine",
  "no", "nobody", "none", "noone", "nor", "not", "nothing", "now", "nowhere", "of",
  "off", "often", "on", "once", "one", "only", "onto", "or", "other", "others",
  "otherwise", "our", "ours", "ourselves", "out", "over", "own", "part", "per",
  "perhaps", "please", "put", "quite", "rather", "re", "really", "regarding", "same",
  "say", "see", "seem", "seemed", "seeming", "seems", "serious", "several", "she",
  "should", "show", "side", "since", "six", "sixty", "so", "some", "somehow",
  "someone", "something", "sometime", "sometimes", "somewhere", "still", "such",
  "take", "ten", "than", "that", "the", "their", "them", "themselves", "then",
  "thence", "there", "thereafter", "thereby", "therefore", "therein", "thereupon",
  "these", "they", "third", "this", "those", "though", "three", "through", "throughout",
  "thru", "thus", "to", "together", "too", "top", "toward", "towards", "twelve", "twenty",
  "two", "under", "unless", "until", "up", "upon", "us", "used", "using", "various",
  "very", "via", "was", "we", "well", "were", "what", "whatever", "when", "whence",
  "whenever", "where", "whereafter", "whereas", "whereby", "wherein", "whereupon",
  "wherever", "whether", "which", "while", "whither", "who", "whoever", "whole",
  "whom", "whose", "why", "will", "with", "within", "without", "would", "yet", "you",
  "your", "yours", "yourself", "yourselves", "'d", "'ll", "'m", "'re", "'s", "'ve"
])
